export default function filterPaidMethod(method) {
  const isCash = method === "CASH";
  if (isCash) return "Efectivo";
  return method;
}
